function lineasDelContenedor(contenedor) {
  const origenY = contenedor.getBoundingClientRect().top;
  const selectores = '[data-contrato-parrafo], p, h1, h2, h3, h4';
  const lineas = [];

  contenedor.querySelectorAll(selectores).forEach((el) => {
    Array.from(el.getClientRects()).forEach((rect) => {
      if (rect.height < 0.5) return;
      lineas.push({
        top: rect.top - origenY,
        bottom: rect.bottom - origenY,
      });
    });
  });

  lineas.sort((a, b) => a.top - b.top || a.bottom - b.bottom);

  const fusionadas = [];
  for (const linea of lineas) {
    const ultima = fusionadas[fusionadas.length - 1];
    if (ultima && Math.abs(ultima.top - linea.top) < 3) {
      ultima.top = Math.min(ultima.top, linea.top);
      ultima.bottom = Math.max(ultima.bottom, linea.bottom);
    } else {
      fusionadas.push({ ...linea });
    }
  }

  return fusionadas;
}

/**
 * Si el corte cae a mitad de una línea visual, retrocede al inicio de esa línea.
 */
function ajustarCorteSinPartirLineas(pageEnd, cursor, lineas) {
  const lineaCortada = lineas.find(
    (l) => l.top < pageEnd - 0.5 && l.bottom > pageEnd + 0.5
  );

  if (!lineaCortada) return pageEnd;

  if (lineaCortada.top > cursor) {
    return lineaCortada.top;
  }

  return pageEnd;
}

/**
 * Si el título de un artículo quedaría solo al pie de la hoja, pasa con su texto a la siguiente.
 */
function ajustarTitulosArticuloHuerfanos(pageEnd, cursor, contenedor) {
  const titulos = contenedor.querySelectorAll('[data-contrato-titulo-articulo]');

  for (const titulo of titulos) {
    const top = titulo.offsetTop;
    const bottom = top + titulo.offsetHeight;

    if (bottom <= cursor || top >= pageEnd) continue;

    const siguiente = titulo.nextElementSibling;
    if (!siguiente) continue;

    const sigBottom = siguiente.offsetTop + siguiente.offsetHeight;

    if (bottom <= pageEnd + 0.5 && sigBottom > pageEnd + 0.5 && top > cursor) {
      return top;
    }
  }

  return pageEnd;
}

/**
 * Llena cada hoja A4 al máximo sin cortar líneas de texto a la mitad.
 */
export function calcularSaltosPaginaContrato(contenedor, altoPaginaPx) {
  const total = contenedor?.scrollHeight || 0;
  if (!contenedor || total <= 0) return [0];
  if (total <= altoPaginaPx) return [0];

  const lineas = lineasDelContenedor(contenedor);
  const saltos = [0];
  let cursor = 0;

  while (cursor + altoPaginaPx < total - 0.5) {
    let pageEnd = cursor + altoPaginaPx;
    pageEnd = ajustarCorteSinPartirLineas(pageEnd, cursor, lineas);
    pageEnd = ajustarTitulosArticuloHuerfanos(pageEnd, cursor, contenedor);

    if (pageEnd <= cursor) {
      pageEnd = Math.min(cursor + altoPaginaPx, total);
    }

    cursor = Math.round(pageEnd);
    if (cursor > saltos[saltos.length - 1]) {
      saltos.push(cursor);
    } else {
      break;
    }
  }

  return saltos;
}

/** Altura del recorte en una hoja (evita solapar con la página siguiente). */
export function alturaContenidoPagina(saltos, indice, altoPaginaPx, totalAltura) {
  const inicio = saltos[indice] ?? 0;
  const siguiente = saltos[indice + 1];
  if (siguiente != null) {
    return Math.max(0, Math.min(altoPaginaPx, siguiente - inicio));
  }
  return Math.max(0, Math.min(altoPaginaPx, totalAltura - inicio));
}
